import axios, { getData } from 'lib/axios'

export const getAllApplicant = async (
  adxJobAdvertisement,
  status,
  applicantType,
  rows,
  current,
  filter,
  search
) => {
  const response = await axios.get(
    `/recruitment/job-postings/${adxJobAdvertisement}/job-posting-candidates?job-ad-candidate-status-id=${status}&application-type-id=${applicantType}&per-page=${rows}&page=${current}${filter}${search}`
  )
  return getData(response)
}

export const getOneApplicant = async (adxJobApplication) => {
  const response = await axios.get(`/recruitment/job-applications/${adxJobApplication}`)
  return getData(response)
}

export const getApplicantDetail = async (jobAdCandidateId) => {
  const response = await axios.get(
    `recruitment/job-posting-candidates/${jobAdCandidateId}/candidate-profile`
  )
  return getData(response)
}
export const getInterviewDetail = async (jobAdCandidateId) => {
  const response = await axios.get(`/recruitment/job-posting-candidates/${jobAdCandidateId}`)
  return getData(response)
}

export const updateApplicant = async (adxJobApplication, action) => {
  const response = await axios.put(`/recruitment/job-applications/${adxJobApplication}/${action}`)
  return getData(response)
}
export const updateCandidateStatus = async (candidate_status_id, data) => {
  const response = await axios.put(
    `/recruitment/job-posting-candidates/${candidate_status_id}`,
    data
  )
  return getData(response)
}
export const searchApplicant = async (adxJobAdvertisement, data) => {
  const response = await axios.post(
    `/recruitment/job-postings/${adxJobAdvertisement}/search-applicant`,
    data
  )
  return getData(response)
}

export const getPersonalityData = async (userId) => {
  const response = await axios.get(`/recruitment/user-personality-test/${userId}`)
  return getData(response)
}

export const getJobFitDetail = async (userId) => {
  const response = await axios.get(`recruitment/job-posting-candidates/${userId}/job-fit`)
  return getData(response)
}

export const getDepartmentData = async () => {
  const response = await axios.get(`recruitment/department-personality-test`)
  return getData(response)
}

export const getEmployeeData = async (department_id) => {
  const response = await axios.get(
    `recruitment/staff-personality-test?department_id=${department_id}`
  )
  return getData(response)
}

export const getAllEmployeeData = async () => {
  const response = await axios.get(`recruitment/staff-personality-test`)
  return getData(response)
}

export const getSimilarityScore = async (data) => {
  const response = await axios.post(`recruitment/personality-test-similarity-score`, data)
  return getData(response)
}

export const getStaffWithNoData = async (searchItem) => {
  const response = await axios.get(`recruitment/pending-personality-test?${searchItem}`)
  return getData(response)
}

export const sendPersonalityTestInvite = async (data) => {
  const response = await axios.post(`recruitment/pending-personality-test/invite`, data)
  return getData(response)
}
